// ============================================================================
// HEBREW TRANSLATIONS - CHAPTER 1: בראשית
// ============================================================================
// רמות 1-13 (13 רמות, 39 שאלות)

export const chapter1Translations = {
  name: "בראשית",
  description: "בְּרֵאשִׁית... דעת מחייה את הרוח",
  
  spiritualWisdom: {
    principle: "דעת מחייה את הרוח",
    scripture: "נִדְמָה עַמִּי מִבְּלִי הַדָּעַת (הושע 4:6)",
    application: "כל פסוק נלמד, כל אמת שמתגלה מזינה את נשמתנו ומחזקת את אמונתנו"
  },
  
  levels: {
    1: {
      name: "הבריאה",
      challenge: "בְּרֵאשִׁית בָּרָא אֱלֹהִים אֵת הַשָּׁמַיִם וְאֵת הָאָרֶץ...",
      easy: {
        question: "בכמה ימים ברא אלוהים את העולם?",
        options: ["5 ימים", "6 ימים", "7 ימים", "8 ימים"],
        hint: "חשבו על יום המנוחה בשבוע",
        funFact: "💡 ביום השביעי נח אלוהים. זה מקור השבת, יום המנוחה השבועי!"
      },
      medium: {
        question: "מה ברא אלוהים ביום הרביעי?",
        options: ["את החיות", "את האדם", "את השמש, הירח והכוכבים", "את הצמחים"],
        hint: "יצורים אלה מאירים את הארץ וקובעים את הזמן",
        funFact: "🌟 המאורות נבראו לקבוע את העונות ואת המועדים!"
      },
      hard: {
        question: "מה המשמעות של כך שהאדם נברא 'בצלם אלוהים'?",
        options: [
          "מראה פיזי זהה",
          "יכולת ליצור ולאהוב",
          "אלמוות טבעי",
          "כוח אלוהי"
        ],
        hint: "מדובר בתכונות רוחניות ואינטלקטואליות",
        funFact: "✨ צלם אלוהים בתוכנו כולל יצירתיות, מצפון מוסרי ויכולת אהבה!"
      }
    },
    
    2: {
      name: "פיתוי הגן",
      challenge: "וְהַנָּחָשׁ הָיָה עָרוּם מִכֹּל חַיַּת הַשָּׂדֶה...",
      easy: {
        question: "איזו חיה פיתתה את חוה בגן?",
        options: ["האריה", "הנחש", "הנשר", "התנין"],
        hint: "חיה זו זוחלת על בטנה",
        funFact: "🐍 הנחש מסמל פיתוי וערמומיות בכל התנ״ך!"
      },
      medium: {
        question: "איזו הבטחה כוזבת נתן הנחש לחוה?",
        options: [
          "תהיו אלמותיים",
          "תהיו עשירים",
          "תהיו כאלוהים",
          "תהיו מאושרים"
        ],
        hint: "הנחש מבטיח התעלות לרמה אלוהית",
        funFact: "🎭 שקר הנחש מערבב אמת ומרמה - טכניקת פיתוי קלאסית!"
      },
      hard: {
        question: "כיצד הנפילה הזו מאירה את המאבק שלנו בין טוב לרע?",
        options: [
          "הרע חזק יותר",
          "רצון חופשי פירושו אחריות",
          "אלוהים נוטש אותנו",
          "הפיתוי בלתי מנוצח"
        ],
        hint: "מדובר ביכולתנו לבחור ולשאת בהשלכות",
        funFact: "🌳 עץ הדעת מסמל את הבחירה המוסרית המגדירה את האנושות!"
      }
    },
    
    3: {
      name: "קין והבל",
      challenge: "שני אחים, שני קורבנות, דרמה נצחית...",
      easy: {
        question: "מי היה הרוצח הראשון בהיסטוריה המקראית?",
        options: ["הבל", "שת", "קין", "אדם"],
        hint: "האח הקנאי של הבל",
        funFact: "⚡ קין הופך לסמל של קנאה אחים הרסנית!"
      },
      medium: {
        question: "מדוע העדיף אלוהים את קורבן הבל?",
        options: [
          "כמות גדולה יותר",
          "הבל היה יפה יותר",
          "הוקרב בלב כן",
          "זה היה בשר"
        ],
        hint: "אלוהים מסתכל על הלב",
        funFact: "❤️ אלוהים מסתכל על הלב, לא רק על המראה החיצוני של מעשינו!"
      },
      hard: {
        question: "מה הסיפור הזה מלמד אותנו על קנאה?",
        options: [
          "קנאה היא טבעית",
          "קנאה לא מבוקרת מובילה להרס",
          "אלוהים מעדיף חלק",
          "תחרות בריאה"
        ],
        hint: "מדובר בתוצאות של אי שליטה ברגשותינו",
        funFact: "🔥 'לַפֶּתַח חַטָּאת רֹבֵץ' - אלוהים מזהיר אותנו לפני הנפילה!"
      }
    },

    4: {
      name: "מבול נח",
      challenge: "וַיְהִי הַגֶּשֶׁם עַל־הָאָרֶץ אַרְבָּעִים יוֹם וְאַרְבָּעִים לָיְלָה...",
      easy: {
        question: "כמה ימים ולילות ירד גשם המבול?",
        options: ["30 ימים", "40 ימים", "50 ימים", "100 ימים"],
        hint: "מספר סמלי בתנ״ך",
        funFact: "☔ המספר 40 מסמל ניסיון ושינוי בתנ״ך!"
      },
      medium: {
        question: "כמה חיות טהורות היה על נח לקחת לתיבה?",
        options: [
          "זוג אחד",
          "2 זוגות",
          "7 זוגות",
          "10 זוגות"
        ],
        hint: "יותר מחיות טמאות",
        funFact: "🦁 החיות הטהורות נועדו לקורבנות אחרי המבול!"
      },
      hard: {
        question: "מה מסמלת התיבה במסע הרוחני שלנו?",
        options: [
          "בריחה מבעיות",
          "ישועה באמונה ובציות",
          "בידוד הכרחי",
          "עליונות המאמינים"
        ],
        hint: "מדובר בישועה המוצעת למאמינים",
        funFact: "🚢 התיבה מבשרת את הישועה: דרך אחת לברוח מהמשפט!"
      }
    },

    5: {
      name: "מגדל בבל",
      challenge: "הָבָה נִבְנֶה־לָּנוּ עִיר וּמִגְדָּל וְרֹאשׁוֹ בַשָּׁמַיִם...",
      easy: {
        question: "מה בלבל אלוהים בבבל?",
        options: ["את התוכניות", "את השפות", "את הכלים", "את המחשבות"],
        hint: "מה שמאפשר תקשורת",
        funFact: "🗣️ בבל היא המקור המיתי לגיוון השפות בעולם!"
      },
      medium: {
        question: "למה האנשים רצו לבנות את המגדל הזה?",
        options: [
          "להגנה",
          "לחיות ביחד",
          "לעשות לעצמם שם ולהגיע לשמיים",
          "לכבד את אלוהים"
        ],
        hint: "מדובר בגאווה ורצון להשתוות לאלוהים",
        funFact: "🏗️ הגאווה של רצון להשתוות לאלוהים תמיד מובילה לבלבול!"
      },
      hard: {
        question: "איך גאוות בבל מתבטאת היום?",
        options: [
          "רק בטכנולוגיה",
          "ברצון האנושי לאוטונומיה מוחלטת ללא אלוהים",
          "בגורדי שחקים",
          "בשפות שונות"
        ],
        hint: "מדובר ברצון להסתדר בלי אלוהים",
        funFact: "💭 בבל מזכירה לנו שאחדות בלי אלוהים הופכת לגאווה הרסנית!"
      }
    },

    6: {
      name: "קריאת אברהם",
      challenge: "לֶךְ־לְךָ מֵאַרְצְךָ וּמִמּוֹלַדְתְּךָ וּמִבֵּית אָבִיךָ...",
      easy: {
        question: "כמה היה גילו של אברהם כשעזב את ארצו?",
        options: ["50 שנה", "65 שנה", "75 שנה", "100 שנה"],
        hint: "גיל מתקדם מאוד להתחיל מחדש",
        funFact: "🚶 בגיל 75, אברהם מתחיל חיים חדשים - אף פעם לא מאוחר מדי!"
      },
      medium: {
        question: "איזו הבטחה משולשת נתן אלוהים לאברהם?",
        options: [
          "עושר, כוח, חכמה",
          "ארץ, זרע, ברכה אוניברסלית",
          "חיים ארוכים, שלום, שגשוג",
          "אמונה, תקווה, אהבה"
        ],
        hint: "הבטחה שנוגעת לכל האנושות",
        funFact: "🌟 ההבטחה לאברהם נוגעת לכל האנושות, לא רק לו!"
      },
      hard: {
        question: "מה 'קפיצת האמונה' של אברהם מלמדת אותנו?",
        options: [
          "אמונה עיוורת מסוכנת",
          "ללכת אחרי אלוהים דורש לוותר על הביטחונות שלנו",
          "אלוהים מעדיף עמים מסוימים",
          "אמונה מבטיחה הצלחה"
        ],
        hint: "מדובר בלבטוח תוך נטישת נקודות העיגון שלנו",
        funFact: "✨ אברהם נקרא 'אבי האמונה' כי האמין בלי לראות!"
      }
    },

    7: {
      name: "עקדת יצחק",
      challenge: "קַח־נָא אֶת־בִּנְךָ אֶת־יְחִידְךָ אֲשֶׁר־אָהַבְתָּ...",
      easy: {
        question: "על איזה הר היה על אברהם להקריב את יצחק?",
        options: ["סיני", "המוריה", "הכרמל", "ציון"],
        hint: "הר זה יהפוך למקום קדוש",
        funFact: "🏔️ הר המוריה יהפוך לאתר של בית המקדש בירושלים!"
      },
      medium: {
        question: "מה סיפק אלוהים במקום יצחק?",
        options: [
          "כבש",
          "איל נאחז בסבך בקרניו",
          "עז",
          "שור"
        ],
        hint: "חיה זכר בוגרת עם קרניים",
        funFact: "🐏 האיל החלופי מבשר את הקורבן החלופי האולטימטיבי!"
      },
      hard: {
        question: "איך הניסיון הזה ממחיש אמונה מוחלטת?",
        options: [
          "אלוהים בוחן באכזריות",
          "אמונה עולה אפילו על אהבת אב",
          "קורבנות אנוש משמחים את אלוהים",
          "אברהם לא באמת אהב את יצחק"
        ],
        hint: "מדובר בלבטוח גם כשאיננו מבינים",
        funFact: "💝 אלוהים תמיד מספק מוצא כשאנחנו בוטחים בו!"
      }
    },

    8: {
      name: "יעקב ועשו",
      challenge: "הגדול יעבוד את הקטן...",
      easy: {
        question: "במה מכר עשו את בכורתו?",
        options: ["זהב", "נזיד עדשים", "בגדים", "יין"],
        hint: "צלחת כדי להשביע את רעבונו",
        funFact: "🍲 רגע של רעב עלה לעשו את ברכתו הנצחית!"
      },
      medium: {
        question: "איך רימה יעקב את אביו יצחק?",
        options: [
          "שינה את קולו",
          "התחפש",
          "כיסה עצמו בעור עיזים",
          "שיקר על שמו"
        ],
        hint: "כדי להידמות לאחיו השעיר",
        funFact: "🎭 יצחק העיוור זיהה את הריח והמישוש אך לא את התרמית!"
      },
      hard: {
        question: "מה מגלה הסיפור הזה על הבחירות שלנו?",
        options: [
          "התרמית לפעמים נחוצה",
          "רצונות מיידיים יכולים לעלות לנו את גורלנו",
          "אלוהים מאשר ערמומיות",
          "הצעיר תמיד מועדף"
        ],
        hint: "מדובר בהשלכות של החלטות אימפולסיביות שלנו",
        funFact: "⚖️ בחירות אימפולסיביות שלנו יכולות להיות בעלות השלכות נצחיות!"
      }
    },

    9: {
      name: "חלום יעקב",
      challenge: "וירא והנה סלם מוצב ארצה וראשו מגיע השמימה...",
      easy: {
        question: "מה ראה יעקב בחלומו?",
        options: [
          "עץ ענק",
          "סולם לשמיים עם מלאכים",
          "מקדש",
          "כוכבים"
        ],
        hint: "אמצעי תקשורת בין שמיים וארץ",
        funFact: "👼 סולם יעקב מסמל את הקשר בין שמיים וארץ!"
      },
      medium: {
        question: "מה עשה יעקב עם האבן שעליה הניח את ראשו?",
        options: [
          "שבר אותה",
          "קבר אותה",
          "הקים אותה ומשח אותה בשמן",
          "לקח אותה איתו"
        ],
        hint: "הפך אותה לאנדרטה קדושה",
        funFact: "🪨 האבן הזו הופכת ל'בית אל' - בית האלוהים!"
      },
      hard: {
        question: "כיצד מקשרת החזון הזה שמיים וארץ בחיינו?",
        options: [
          "רק דרך חלומות",
          "דרך תפילה שמקימה גשר לאלוהי",
          "דרך מלאכים שומרים",
          "דרך מקומות קדושים"
        ],
        hint: "מדובר בתקשורת שלנו עם אלוהים",
        funFact: "🌉 התפילה היא הסולם האישי שלנו לשמיים!"
      }
    },

    10: {
      name: "יוסף נמכר על ידי אחיו",
      challenge: "הנה בעל החלומות הלזה בא...",
      easy: {
        question: "כמה אחים היו ליוסף?",
        options: ["7 אחים", "10 אחים", "11 אחים", "12 אחים"],
        hint: "אחד פחות ממספר שבטי ישראל",
        funFact: "👨‍👨‍👦‍👦 12 בני יעקב יהפכו ל-12 שבטי ישראל!"
      },
      medium: {
        question: "בכמה כסף נמכר יוסף?",
        options: [
          "10 שקלים",
          "20 שקלים",
          "30 שקלים",
          "50 שקלים"
        ],
        hint: "מחיר של עבד",
        funFact: "💰 20 שקלי כסף, מחיר עבד באותה תקופה!"
      },
      hard: {
        question: "כיצד הקנאה הופכת לכלי של התכנית האלוהית?",
        options: [
          "אלוהים מאשר קנאה",
          "הרע שנעשה מומר לטוב על ידי אלוהים",
          "קנאה היא נחוצה",
          "האחים צדקו"
        ],
        hint: "מדובר בהשגחה אלוהית שהופכת רע לטוב",
        funFact: "🎨 אלוהים הופך אפילו את המעשים הגרועים ביותר שלנו ליצירת מופת של חסד!"
      }
    },

    11: {
      name: "יוסף בכלא",
      challenge: "ויהי ה' את יוסף ויט אליו חסד...",
      easy: {
        question: "איזו מתנה מיוחדת היתה ליוסף?",
        options: [
          "לנבא",
          "לפתור חלומות",
          "לרפא חולים",
          "לדבר עם בעלי חיים"
        ],
        hint: "יכולת הקשורה לחלומות",
        funFact: "💭 חלומות נחשבו למסרים אלוהיים בעולם העתיק!"
      },
      medium: {
        question: "אילו משרתים של פרעה היו בכלא עם יוסף?",
        options: [
          "השר והסופר",
          "שר המשקים ושר האופים",
          "הרופא והשומר",
          "הטבח והגנן"
        ],
        hint: "זה ששירת את היין וזה ששירת את הלחם",
        funFact: "🍷 שר המשקים טעם את יין המלך כדי למנוע הרעלה!"
      },
      hard: {
        question: "מה מלמד אותנו יוסף על נאמנות בצרה?",
        options: [
          "אי צדק קביל",
          "נאמנות לאלוהים עולה על הנסיבות",
          "הכלא משנה אנשים",
          "צריך להתנקם"
        ],
        hint: "מדובר בלהישאר נאמן אפילו במבחנים",
        funFact: "⭐ אפילו בכלא, יוסף נשאר ישר ואלוהים העלה אותו!"
      }
    },

    12: {
      name: "חלומות פרעה",
      challenge: "שבע פרות בריאות... שבע פרות רזות...",
      easy: {
        question: "כמה פרות רזות אכלו את הפרות הבריאות?",
        options: ["5", "6", "7", "8"],
        hint: "מספר מושלם",
        funFact: "🐄 המספר 7 מסמל שלמות ומלאות בתנ\"ך!"
      },
      medium: {
        question: "מה סימלו ה-7 שנים בחלום?",
        options: [
          "7 שנות מלחמה ואז שלום",
          "7 שנות שפע ואז 7 שנות רעב",
          "7 שנות מחלה ואז בריאות",
          "7 שנות גשם ואז בצורת"
        ],
        hint: "מחזור של שפע ומחסור",
        funFact: "🌾 יוסף הציל את מצרים ואת משפחתו בזכות הפירוש הזה!"
      },
      hard: {
        question: "כיצד חכמה אלוהית הופכת משברים?",
        options: [
          "מונעת כל משבר",
          "נותנת ראיה מוקדמת להתכונן",
          "מעניש את הרשעים",
          "מעשיר את המאמינים"
        ],
        hint: "מדובר בהכנה וציפייה מראש",
        funFact: "💡 החכמה האלוהית הופכת משברים להזדמנויות של ישועה!"
      }
    },

    13: {
      name: "פיוס האחים",
      challenge: "אני יוסף אחיכם אשר מכרתם אותי...",
      easy: {
        question: "מה שם יוסף בשק של בנימין?",
        options: [
          "זהב",
          "טבעתו",
          "גביע הכסף שלו",
          "מכתב"
        ],
        hint: "חפץ אישי יקר",
        funFact: "🏆 הגביע גם שימש ל'קריאה' של העתיד במים!"
      },
      medium: {
        question: "איזה ביטוי מפורסם אמר יוסף על הרע שהפך לטוב?",
        options: [
          "אני סולח לכם",
          "אתם חשבתם עלי רעה, ואלוהים חשבה לטובה",
          "נשכח את העבר",
          "הנקמה של אלוהים"
        ],
        hint: "משפט על ההשגחה האלוהית",
        funFact: "✨ המשפט הזה מסכם את כל ההשגחה האלוהית בחיינו!"
      },
      hard: {
        question: "כיצד סליחה שוברת מעגלי נקמה?",
        options: [
          "שוכחת את הרע",
          "משחררת את הפוגע והנפגע להתחלה חדשה",
          "מעניש קודם",
          "שומר מרחק"
        ],
        hint: "מדובר בשחרור הדדי",
        funFact: "🕊️ סליחת יוסף מקדימה את הסליחה האלוהית האוניברסלית!"
      }
    }
  }
};

export default chapter1Translations;
